import React from 'react';
import { IconButton } from '../IconButton/IconButton';
import { useTranslation } from 'react-i18next';
import { useShareContext } from '../../context/ShareContext';
import { useApp } from '../../hooks';

interface SocialIconsShareWrapperProps {
  onClick?: () => void;
  children?: React.ReactNode;
  socialChannel: string;
}

export const SocialsIconsShareWrapper: React.FunctionComponent<SocialIconsShareWrapperProps> = ({
  onClick = () => {},
  children,
  socialChannel,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { shareItems } = useShareContext();
  const { showToast } = useApp();

  async function onCopy() {
    onClick();
    try {
      await navigator.clipboard.writeText(
        shareItems[socialChannel].url as Extract<
          keyof typeof shareItems,
          string
        >,
      );

      showToast({
        type: 'success',
        message: t('fundraising.shareLinkSocialIcon'),
        dismissAfter: 5000,
      });
    } catch (e) {
      showToast({
        type: 'warning',
        message: t('fundraising.shareLinkSocialIconFailed'),
        dismissAfter: 5000,
      });
    }
  }

  return (
    <IconButton
      data-qa="SocialIconsShareWrapper"
      onClick={onCopy}
      id={`socialIconsButton${socialChannel}`}
    >
      <a href={`#socialIconsButton${socialChannel}`}>{children}</a>
    </IconButton>
  );
};
